import React, { Component } from "react";
import { inject } from "mobx-react";
import PropTypes from "prop-types";
import Icons from "../../../icons/fluent-icons.svg";

import {
  ContentStorePropTypes,
  BaseTagStorePropTypes
} from "../../../utilities/propTypes";

class GeneralItemCard extends Component {
  generateTagSpans = tags =>
    tags.map(tag => (
      <React.Fragment key={tag}>
        <button
          className="label label-tag learn-item-label-tag"
          onClick={() => this.searchTag(tag)}
          type="button"
        >
          {tag}
        </button>{" "}
      </React.Fragment>
    ));

  searchTag = tag => {
    const { generalItemStore, baseTagStore } = this.props;
    generalItemStore.load(baseTagStore.baseTag, tag);
  };

  render() {
    const { cardData } = this.props;

    return (
      <div className="col-lg-6" aria-label={cardData.title}>
        <div className="media">
          <div className="d-flex">
            <div className="media-left" aria-hidden="true">
              <svg height="32" width="32" className="icon-svg icon-modifier">
                <use xlinkHref={`${Icons}#${cardData.icon}`} />
              </svg>
            </div>
            <div className="media-body">
              <h3 className="media-heading small">
                <a href={cardData.url} target="_blank" rel="noopener noreferrer">{cardData.title}</a>
              </h3>
              <p>{cardData.description}</p>
            </div>
          </div>
          <div className="media-bottom text-right">
            {this.generateTagSpans(cardData.tags)}
          </div>
        </div>
      </div>
    );
  }
}

GeneralItemCard.propTypes = {
  generalItemStore: ContentStorePropTypes.isRequired,
  baseTagStore: BaseTagStorePropTypes.isRequired,
  cardData: PropTypes.shape({
    url: PropTypes.string,
    icon: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    tags: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.string)
    ])
  }).isRequired
};

export default inject("generalItemStore", "baseTagStore")(GeneralItemCard);
